app.service('footerRecentArticles', function (lazyLoad, viewPoint) {

	let $self;
	let $rotatorList, $rotatorContainer, $rotatorListItem;
	let rotatorData = {};

	function setInitialRotatorData(){
		rotatorData.containerWidth = $rotatorContainer[0].offsetWidth;
		rotatorData.listItemsCount = $rotatorList[0].children.length;
		rotatorData.listItemWidth = $rotatorListItem.outerWidth(true); // width with margin
		rotatorData.lastListItemWidth = $rotatorListItem.last().outerWidth(true); // width with margin
		rotatorData.listWidth = rotatorData.listItemWidth * (rotatorData.listItemsCount - 1) + rotatorData.lastListItemWidth; // ostatni element zwykle nie ma marginesu
		rotatorData.fullItemsOnView = Math.floor(rotatorData.containerWidth / rotatorData.listItemWidth);
		rotatorData.overflowedElements = rotatorData.listItemsCount - rotatorData.fullItemsOnView;
		rotatorData.scrollCount = 0;
		rotatorData.scrollPosition = 0;
		rotatorData.scrollToEnd = rotatorData.maxScroll - rotatorData.scrollPosition;
		rotatorData.maxScroll = rotatorData.listWidth - rotatorData.containerWidth;
	}
	function setRotatorAttributes() {
		$rotatorList.attr('data-overflowed-elements', rotatorData.overflowedElements > rotatorData.scrollCount ? rotatorData.overflowedElements - rotatorData.scrollCount : 0);
		$rotatorList.attr('data-scroll-count', rotatorData.scrollCount);
		$rotatorList.attr('data-scroll-position', rotatorData.scrollPosition);
		$rotatorList.attr('data-scroll-end', rotatorData.scrollToEnd);
		$rotatorList.animate({ scrollLeft: rotatorData.scrollPosition }, 500);
	}

	function initRotatorInfo() {
		setInitialRotatorData();
		setRotatorAttributes();
	}

	function slideElementFrom(direction) {
		rotatorData.scrollPosition = $rotatorList.attr('data-scroll-position') / 1 || 0;
		rotatorData.scrollToEnd = rotatorData.maxScroll - rotatorData.scrollPosition;
		rotatorData.scrollCount = $rotatorList.attr('data-scroll-count') / 1 || 0;
		// console.log('containerWidth: ' + rotatorData.containerWidth + ', listWidth: ' + rotatorData.listWidth + ', maxScroll: '+ rotatorData.maxScroll + ', listItemWidth: ' + rotatorData.listItemWidth + ', scrollToEnd: ' + rotatorData.scrollToEnd + ', scrollPosition: ' + rotatorData.scrollPosition);

		if(rotatorData.scrollToEnd >= 0 && rotatorData.scrollToEnd <= rotatorData.maxScroll) {
			if(direction === 'right') {
				rotatorData.scrollCount++;
				rotatorData.scrollPosition = rotatorData.scrollToEnd > rotatorData.listItemWidth ? rotatorData.scrollPosition + rotatorData.listItemWidth : rotatorData.maxScroll;
			} else {
				rotatorData.scrollCount--;
				rotatorData.scrollPosition = rotatorData.scrollPosition != rotatorData.maxScroll ? rotatorData.scrollPosition - rotatorData.listItemWidth : rotatorData.scrollPosition - rotatorData.maxScroll % rotatorData.listItemWidth;
			}
			setRotatorAttributes();
		}
	}

	function init() {
		$self = $('#footer-recent-articles');

		if ($self.length) {

			$rotatorContainer = $('.simple-rotator', $self);
			$rotatorList = $('.simple-rotator-list', $rotatorContainer);
			$rotatorListItem = $('.simple-rotator-item', $rotatorList);

			initRotatorInfo();
			lazyLoad.update();
			$rotatorListItem.each(function () {
				const $item = $(this);
				$item.on('focusin', function (e) {
					// Handle item focus
					e.preventDefault();
					e.stopPropagation();
					lazyLoad.update();

					if(($item[0].offsetLeft + $item.outerWidth(true)) > ($rotatorList[0].scrollLeft + rotatorData.containerWidth) || $item[0].offsetLeft < $rotatorList[0].scrollLeft) {
						// If the item is before the current scroll position
						$rotatorList.animate({ scrollLeft: $item[0].offsetLeft }, 500, function() {
							rotatorData.scrollPosition = $item[0].offsetLeft;
							// rotatorData.scrollToEnd = rotatorData.maxScroll - rotatorData.scrollPosition;
							$rotatorList.attr('data-scroll-position', rotatorData.scrollPosition);
						});
					}

					if ($item.index() === 0) {
						// pierwszy element
						initRotatorInfo();
					} else if ($item.index() === rotatorData.listItemsCount - 1) {
						// ostatni element
						$('.js-slide-right', $rotatorContainer).hide();
					} else {
						// pozostałe elementy
						$('.js-slide-right', $rotatorContainer).show();
					}
				});
			});

			$rotatorContainer.on('touchend', $rotatorListItem, function () {
				lazyLoad.update();
			}).on('click', '.js-slide-right', function () {
				console.log('click right');
				slideElementFrom('right');
				lazyLoad.update();
			}).on('click', '.js-slide-left', function () {
				console.log('click left');
				slideElementFrom('left');
			}).on('keyup', '.js-slide-right', function (event) {
				if (event.key === 'Enter' || event.key === ' ') {
					event.preventDefault();
					event.stopPropagation();
					slideElementFrom('right');
					lazyLoad.update();
				}
			}).on('keyup', '.js-slide-left', function (event) {
				if (event.key === 'Enter' || event.key === ' ') {
					event.preventDefault();
					event.stopPropagation();
					slideElementFrom('left');
				}
			}).on('keydown', '.js-slide-right', function (event) {
				if (event.key === 'Enter' || event.key === ' ') {
					event.preventDefault();
					event.stopPropagation();
				}
			}).on('keydown', '.js-slide-left', function (event) {
				if (event.key === 'Enter' || event.key === ' ') {
					event.preventDefault();
					event.stopPropagation();
				}
			});

			$rotatorList.on('keyup', function (event) {
				if (event.key === 'ArrowRight') {
					event.preventDefault();
					event.stopPropagation();
					slideElementFrom('right');
				} else if (event.key === 'ArrowLeft') {
					event.preventDefault();
					event.stopPropagation();
					slideElementFrom('left');
				}
			});

			$(window).on('resize', $rotatorContainer,function(){
				initRotatorInfo();
			});
		}
	}


	return {init};
});
